module.exports = __webpack_public_path__ + "img/sun.b9ed07b4.svg";